
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const WalletDiscover = ({ discover, img, icons }) => {
    const Item = ({ item, icons }) => {
        return <li className={'discover_info_items_item'}>
            {icons[item.icon]}
            <div>
                <span>{item.title}</span>
                {item.description && <p>{item.description}</p>}
            </div>

        </li>;
    };
    return (<section className={'discover'}>
            <div className="container">
                <div className="discover_wrapper">
                    <div className="discover_media">
                        <picture>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/${img}_small.webp`} type="image/webp"/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/${img}.webp`} type="image/webp"/>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/${img}_small.png`}/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/${img}.png`}/>
                            <img src={`/img/pages/ecosystem/${img}.png`} alt={`Discover ColdWare Wallet`} width={582} height={923} className='discover_media_img'/>
                        </picture>
                    </div>
                    <div className="discover_info">
                        {discover.label && <p className={'discover_info_label'}>{discover.label}</p>}
                        <h2 className={'discover_info_title'}>{discover.title}</h2>
                        {discover.description && <p className={'discover_info_description'}>{discover.description}</p>}
                        <ul className={'discover_info_items'}>
                            {discover.items.map(item => {
            return <Item key={item.key} item={item} icons={icons}/>;
        })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>);
};
export default WalletDiscover;

    async function __Next_Translate__getStaticProps__1976335831b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/Discover/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1976335831b__ as getStaticProps }
  